import { render, staticRenderFns } from "./dynamic-shareAlert.vue?vue&type=template&id=ed2b3344&scoped=true&"
import script from "./dynamic-shareAlert.vue?vue&type=script&lang=js&"
export * from "./dynamic-shareAlert.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-shareAlert.vue?vue&type=style&index=0&id=ed2b3344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b3344",
  null
  
)

export default component.exports